<template>
  <div class="overlay" :class="{active:isActive}">
      <div class="overlay-body">
          <slot></slot>
      </div>
  </div>
</template>

<script src="./mvt-overlay.js"></script>
<style lang="scss">
@use "./mvt-overlay.scss" as *;
</style>